import { reduxStoreTypes } from '@type/redux-store';

export const SET_BUTTONS: reduxStoreTypes.ButtonsType = 'SET_BUTTONS';
export const getButtons = (params: Omit<reduxStoreTypes.ButtonAction, 'type'>) => ({
    type: SET_BUTTONS,
    ...params
})